import { render, staticRenderFns } from "./TerapieComponent.vue?vue&type=template&id=87ff0978"
import script from "./TerapieComponent.vue?vue&type=script&lang=js"
export * from "./TerapieComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports